import React from 'react';
import Dashboard from 'templates/Dashboard';
import ContainerForm from '../../components/organisms/dashboard/ContainerForm';

const DashboardPage: React.FC = () => {
  return <Dashboard Container={ContainerForm} />;
};

export default DashboardPage;
